interface IgetVerificationQueryKeys {
  reportName: string;
  applicationId: number;
  applicantId: number;
  verificationId: number | undefined;
}

export const getVerificationQueryKeys = ({
  reportName,
  applicationId,
  applicantId,
  verificationId
}: IgetVerificationQueryKeys) => {
  return [
    "REPORTS",
    {
      reportName,
      applicationId,
      applicantId,
      verificationId
    }
  ];
};
